export async function fetchOilSp500({ oil = 'BZ=F', equity = '^GSPC', range = '5Y' } = {}) {
  const params = new URLSearchParams({
    oil,
    equity,
    range,
    include_bars: '1',
  });
  const response = await fetch(`/api/investing/oil-sp500?${params}`);
  let body = null;
  try {
    body = await response.json();
  } catch {
    body = null;
  }
  if (!response.ok) {
    throw new Error(body?.error || `HTTP ${response.status}`);
  }
  return body;
}
